import styled from 'styled-components'
import { breakpoints } from '@/styles'

const FilterBar = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    width: 100%;
    margin-bottom: 24px;
  }
  ${props =>
    props.static &&
    `
    position: static;
  `}
`

export default FilterBar
